<template>
    <div class="map-wrapper">
        <div class="res-content-wrapper">
            <ion-grid class="loc-search">
                <ion-row>
                    <ion-col size-md="11" size-xs="12">
                        <div class="loc-wrpaper">
                            <span class="rp-desktop">Location:</span>
                            <span class="rp-mobile"><img src="/assets/images/common/search/116836@2x.png" class="lense-icon"/></span>
                            <input type="text" id="pac-input" v-model="locationAdd" @click="clearInputs" placeholder="Enter Location" />
                            <img src="../../assets/locate.svg" class="map-marker-icon" v-on:click="config">
                        </div>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        
        <div id="res-map"></div>
        <div class="card-list-wrapper" v-if="chargeNow">
            <div>
                <ion-grid>
                    <ion-row>
                        <ion-col>
                            <div class="qrcodeStream">
                                <qrcode-stream  v-if="isShowingCamera" @detect="onDetect"/>
                            </div> 
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
        </div>
        <div class="card-list-wrapper">
            <div class="card-list" v-if="cardType === true">
                <ion-grid>
                    <ion-row>
                        <ion-col size-md="6" size-xs="12">
                            <div class="card-list-content">
                                <p class="ion-no-margin title">{{selectedMarker.name}}<span v-if="selectedMarker.rating != 0">&nbsp;{{selectedMarker.rating}} &nbsp;<ion-icon class="star-rating" :icon="star"></ion-icon></span></p>
                                <p class="ion-no-margin loc">{{selectedMarker.address.line1}},
                                    {{selectedMarker.address.city}}</p>
                                <p class="ion-no-margin time">Open : {{opensAt}} - {{closesAt}}</p>
                            </div>
                        </ion-col>
                        <ion-col size-md="6" size-xs="12">
                            <div class="card-list-booking">
                                <p class="ion-no-margin">{{selectedMarkerDistance}}</p>
                                <div class="call-options">
                                    <a v-bind:href="teleUrl" class="call-img-a">
                                        <img class="call-img" src="../../assets/card-call.png" />
                                    </a>
                                    <img @click="googleMapApp()" class="map-img" src="../../assets/card-map.png" />
                                    <ion-button class="book-btn" v-if="stationMarkerStatus == 'deactivedstation'"
                                        disabled @click="bookNow()" expand="block" shape="round">Next</ion-button>
                                    <ion-button class="book-btn" v-if="stationMarkerStatus != 'deactivedstation'"
                                        @click="bookNow()" expand="block" shape="round">Next</ion-button>
                                </div>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
        </div>
        <div class="map-overlay" v-if="mapClickFlag"></div>
        <div class="spinnerWrapper">
                <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
        <!-- develop by vinoth on 07.09.2023  class="rp-mobile"-->
        <div v-if="!isShowingCamera"  class="rp-mobile">
            <ion-fab horizontal="center">
                <ion-fab-button  @click="openScannerForTagId()" class="chargeNowFab">
                    <!-- <ion-icon name="barcode"></ion-icon> -->
                    <!-- <ion-icon name="qrScanner" class="qr-svg" size="large"></ion-icon> -->
                    <img src="../../../public/assets/images/reservation/qr_code.svg" class="qr-svg">
                </ion-fab-button>
            </ion-fab>
        </div>
        <div v-if="isShowingCamera"  class="rp-mobile">
            <ion-fab horizontal="center" size="large">
                <ion-fab-button  @click="closeScanner()" class="chargeNowFab"> Cancel
                    <!-- <ion-icon name="barcode"></ion-icon> -->
                    <!-- <ion-icon name="qrScanner" class="qr-svg" size="large"></ion-icon> -->
                    <!-- <img src="../../../public/assets/images/reservation/qr_code.svg" class="qr-svg"> -->
                </ion-fab-button>
            </ion-fab>
        </div>
    </div>
</template>

<script>
import { IonGrid, IonRow, IonCol, IonFab, IonFabButton, IonSpinner, IonButton, IonIcon } from "@ionic/vue";
import { QrcodeStream } from "vue-qrcode-reader";
import { defineComponent } from "vue";
import { Coordiate } from '@/entity/location/corodinate';
import { EVCStationService } from "@/service/evcstation/stations.service";
import { LocalStorage } from "../../data/localstorage";
import { ConfigurationService } from "../../service/configuration";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";
// import { error } from 'winston';
// import TagIdScannerModal from "./TagIdScannerModal.vue";
import { trash, star,download, homeSharp } from 'ionicons/icons';

import { Network } from '@capacitor/network';

import { EVChargerType } from '@/entity/station/evcharger';

import { RecentlySelectedFilterCriteria } from '@/entity/station/reservation';

export default defineComponent ({
    name: 'GoogleMap',
    components: {
        IonGrid, 
        IonRow, 
        IonCol, 
        IonFab, 
        IonFabButton, 
        IonSpinner, 
        IonButton,
        IonIcon,
        QrcodeStream
    },
    data() {
        return {
            trash, 
            star,
            download, 
            homeSharp,
            map: null,
            locationAdd: "",
            image: '159615-1.png',
            iconBase: null,
            icons: null,
            currentLoc: {},
            teleUrl: "",
            opensAt: "",
            closesAt: "",
            cardType: false,
            selectedMarker: [],
            markerCoordinates: [],
            selectedMarkerDistance: "",
            selectedObjValue: {},
            markerArray: null,               
            mapClickFlag:false,
            loaderTab:false,
            configData: null,
            isShowingCamera: false,
            chargeNow: false
        }
    },
    async mounted() {
        const status = await Network.getStatus();
        if(status.connected) {
            this.iconBase = '/assets/images/reservation/';
            this.icons = {
                deactivedstation: {
                    icon: this.iconBase + '159615-1.png'
                },
                activestation: {
                    icon: this.iconBase + '159615.png'
                },
                current: {
                    icon: this.iconBase + '75689.png'
                },
                selectedMarker: {
                    icon: this.iconBase + 'mark.png'
                }, 
                thirsdPartyStation: {
                    icon: this.iconBase + '159615_01.png'
                },
                thirdPartyselectedMarker: {
                    icon: this.iconBase + 'ThirdPartymark.png'
                },
                cpoStations: {
                    icon: this.iconBase + '159615_unrh.png'
                },
                cpoStationsMarker: {
                    icon: this.iconBase + 'mark_unrh.png'
                }
            };
            try {
                const element = document.getElementById('res-map');

                var myStyles =[
                    {
                        featureType: "poi",
                        elementType: "labels",
                        stylers: [
                            { visibility: "off" }
                        ]
                    }
                ];

                const options = {
                    zoom: 15,
                    styles: myStyles,
                    mapTypeControl: false,
                    draggable: true,
                    scaleControl: false,
                    scrollwheel: true,
                    navigationControl: false, 
                    streetViewControl: false,
                    zoomControl: true,
                    zoomControlOptions: {
                            position: google.maps.ControlPosition.RIGHT_CENTER
                    },
                    fullscreenControl: false,
                    chargerTypesSelectedValue: null,
                    chargerOutputSelectedValue: null,
                    chargerPortSelectedValue: null,
                    center: { lat: 11.0487119985167, lng: 77.048380874338 }
                }
                this.map = new google.maps.Map(element, options);

                var input = document.getElementById('pac-input');
                this.autoCompleteFormation(input, this)
                this.config()
            } catch(error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }

        }

        //this.getLocation()
    },

    methods: {
        filterCall() {
           
            //*********************Changes Start*******************************************
            //* Rel 2.1             Vinoth                9th Apr 2025                  *
            //*****************************************************************************
            // here filter data is get from local storage instead of geting from database. 
            // new EVCStationService().recentlySelectedFilterCriteriaForUser(new LocalStorage().user).then((loadFilterdata) => {
            //     console.log('loadFilterdata', loadFilterdata)
            //     this.chargerTypesSelectedValue = loadFilterdata.chargerType
            //     this.chargerOutputSelectedValue = loadFilterdata.outputType
            //     this.chargerPortSelectedValue = loadFilterdata.portType
            //     this.serviceCall()
            // }).catch((error) => {
            //     let serviceError = migratedTryParseServiceError(error);
            //     new ToastUtils().presentToast(serviceError.description);
            // })
            //*********************Changes End*******************************************
            //* Rel 2.1             Vinoth                9th Apr 2025                  *
            //*****************************************************************************
            let loadFilterdata = JSON.parse(localStorage.getItem('userFilterData'));
            if(loadFilterdata != null) {
                // let filterCriteria = new RecentlySelectedFilterCriteria(
                //     new EVChargerType(loadFilterdata.chargerType.code),                       
                //     {id: loadFilterdata.chargerOutput.code},
                //     {id: loadFilterdata.chargerPort.code}
                // )
                let filterCriteria = new RecentlySelectedFilterCriteria(
                    new EVChargerType(loadFilterdata.chargerType.code),                       
                    {id: ""},
                    {id: ""}
                )
                this.chargerTypesSelectedValue = filterCriteria.chargerType
                this.chargerOutputSelectedValue = filterCriteria.outputType
                this.chargerPortSelectedValue = filterCriteria.portType
            }
            this.serviceCall()
        },
        clearInputs() {
            document.getElementById("pac-input").value = "";
            this.locationAdd = "";
            this.locationAdd = null;
        },
        async config() {
            await new ConfigurationService().configuration().then((data) => {
                this.configData = data;
                this.getLocation()
            }).catch((error) => {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            });
        },
        autoCompleteFormation(input, thisValue) {
            try {
                var autocomplete = new google.maps.places.Autocomplete(input);
                autocomplete.bindTo('bounds', this.map);
                autocomplete.setFields(
                    ['address_components', 'geometry', 'icon', 'name']);
                autocomplete.addListener('place_changed', function () {
                    thisValue.deleteMarkers()
                    var place = autocomplete.getPlace();
                    if (!place.geometry) {
                        window.alert("No details available for input: '" + place.name + "'");
                        return;
                    }
                    thisValue.currentLoc = {
                        latitude: place.geometry.location.lat(),
                        longitude: place.geometry.location.lng(),
                        type: 'current'
                    };
                    // localStorage.setItem("currentLoc", JSON.stringify(thisValue.currentLoc))
                    localStorage.setItem("Autocomplete", input.value)
                    this.locationAdd = input.value;
                    thisValue.map.setCenter(place.geometry.location);
                    thisValue.map.setZoom(thisValue.configData.googleMapZoomLevel)
                    thisValue.filterCall()
                });
            } catch(error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
            
        },
        serviceCall() {
            this.markerCoordinates = [];
            new EVCStationService().stationsAroundLocationForUser(new Coordiate(this.currentLoc.latitude, this.currentLoc.longitude),
                new LocalStorage().user, {
                chargerType: this.chargerTypesSelectedValue,
                outputType: this.chargerOutputSelectedValue,
                portType: this.chargerPortSelectedValue,
                radius: Number(this.configData.stationSearchRadius),
                viewType:"MAP"       
            }).then((data) => {
                this.masterData = data;
                this.locationDataFormation();
                // Here once station is got from backend based filter we are clearing filter data local storage, then user need to add filter again, 
                localStorage.removeItem('userFilterData')
            }).catch((error) => {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            })
        },
        getLocation() {
            try {
                this.deleteMarkers()
                var geocoder = new google.maps.Geocoder();
                var activeInfoWindow = null
                var infowindow = new google.maps.InfoWindow();
                this.map.addListener('click', (e) => {
                    if (activeInfoWindow) {
                        activeInfoWindow.close();
                    }
                    activeInfoWindow = infowindow
                    this.placeMarkerAndPanTo(e.latLng)
                    this.cardType = false;
                });
                var thiscurrentLoc = JSON.parse(localStorage.getItem("currentLoc"));
                var thislocationAdd = localStorage.getItem("Autocomplete");
                // if (thiscurrentLoc && thislocationAdd) {
                //     this.mapViegetLocation();
                // } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((position) => {
                    var pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    this.currentLoc = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        type: 'current'
                    };
                    // localStorage.setItem("currentLoc", JSON.stringify(this.currentLoc));
                    geocoder.geocode({ 'location': pos }, (results, status) => {
                        this.locationAdd = results[0].formatted_address;
                        localStorage.setItem("Autocomplete", this.locationAdd);
                    });
                    this.map.setCenter(pos);
                    this.map.setZoom(this.configData.googleMapZoomLevel)
                    // this.addMarker();
                    this.filterCall()
                    },(error) => {
                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                console.log("User denied the request for Geolocation.")
                                break;
                            case error.POSITION_UNAVAILABLE:
                                console.log("Location information is unavailable.")
                                break;
                            case error.TIMEOUT:
                                console.log("The request to get user location timed out.")
                                break;
                            case error.UNKNOWN_ERROR:
                                console.log("An unknown error occurred.")
                                break;
                        }
                    });
                } 
            } catch(error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
            
            // }
        },
        placeMarkerAndPanTo(latLng) { 
            try {
                this.mapClickFlag =true;    
                this.loaderTab =true; 
                var geocoder = new google.maps.Geocoder();
                this.deleteMarkers()
                this.currentLoc = {
                    latitude: latLng.lat(),
                    longitude: latLng.lng(),
                    type: 'current'
                };                
            
                navigator.geolocation.getCurrentPosition((position) => {
                    var pos = {
                        lat: this.currentLoc.latitude,
                        lng: this.currentLoc.longitude
                    };
                    geocoder.geocode({ 'location': pos }, (results, status) => {
                        this.locationAdd = results[0].formatted_address;
                        localStorage.setItem("Autocomplete", this.locationAdd);
                    });
                });
                localStorage.setItem("currentLoc", JSON.stringify(this.currentLoc))
                this.filterCall()
            } catch(error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);

            }
            
        },
        locationDataFormation() {
            this.masterData.forEach((data) => {
                // var stationStatus = (data.status.id == "A") ? "activestation" : "deactivedstation";
                var stationStatus = "";
                if(data.thirdPartyStatus.id == "Y") {
                    stationStatus = "thirsdPartyStation";
                } else if(data.visibilityStatus.id == "Y") {
                    stationStatus = "cpoStations"
                } else {
                    stationStatus = (data.status.id == "A") ? "activestation" : "deactivedstation";
                }
                
                let locationObj = {
                    latitude: data.coordinate.latitude,
                    longitude: data.coordinate.longitude,
                    type: stationStatus,
                    id: data.id
                }
                this.markerCoordinates.push(locationObj);

            })
            this.addMarker();
        },
        googleMapApp() {
            try {
                if /* if we're on iOS, open in Apple Maps */
                    ((navigator.platform.indexOf("iPhone") != -1) ||
                    (navigator.platform.indexOf("iPod") != -1) ||
                    (navigator.platform.indexOf("iPad") != -1))
                    window.open("maps://maps.google.com/maps?daddr=" + this.selectedMarker.coordinate.latitude + "," + this.selectedMarker.coordinate.longitude + "&amp;ll=");
                else /* else use Google */
                    window.open("https://maps.google.com/maps?daddr=" + this.selectedMarker.coordinate.latitude + "," + this.selectedMarker.coordinate.longitude + "&amp;ll=");
            } catch(error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
            
        },
        bookNow() {
            localStorage.setItem("teleUrl", this.teleUrl)
            localStorage.setItem("selectedMarker", JSON.stringify(this.selectedMarker))
            localStorage.setItem("opensAt", this.opensAt)
            localStorage.setItem("closesAt", this.closesAt)
            this.$router.push({ name: "bookNow" });
        },
        addMarker() {
            try {
                this.markerCoordinates.push(this.currentLoc);
                const markerMasterData = this.masterData
                this.markerArray = []
                this.markerCoordinates.forEach((coord) => {
                    const position = new google.maps.LatLng(coord.latitude, coord.longitude);
                    const marker = new google.maps.Marker({
                        position,
                        map: this.map,
                        icon: this.icons[coord.type].icon,
                        id: coord.id,
                        iconType: coord.type
                    });
                    this.markerArray.push(marker)
                    if (coord.type != "current") {
                        marker.addListener('click', () => {
                            this.locationAdd = localStorage.getItem("Autocomplete");
                            this.$nextTick(function () {
                                this.cardType = true;

                                var selectedMarker = markerMasterData.filter((data) => {
                                    return data.id === marker.id;
                                });
                                this.selectedObjValue = selectedMarker;
                                for (var i = 0; i < this.markerArray.length; i++) {
                                    this.markerArray[i].setIcon(this.icons[this.markerArray[i].iconType].icon); // set back to default
                                }
                                // Below code is commented by vinoth on 25.05.2023 as per thirdPartyStation request
                                // marker.setIcon(this.icons["selectedMarker"].icon);
                                if(selectedMarker[0].thirdPartyStatus.id == 'N' && selectedMarker[0].visibilityStatus.id == 'N') {
                                    marker.setIcon(this.icons["selectedMarker"].icon);
                                } else if(selectedMarker[0].visibilityStatus.id == 'Y' && selectedMarker[0].thirdPartyStatus.id == 'N') {
                                    
                                    marker.setIcon(this.icons["cpoStationsMarker"].icon);
                                } else if(selectedMarker[0].thirdPartyStatus.id == 'Y'){
                                    marker.setIcon(this.icons["thirdPartyselectedMarker"].icon);
                                }
                                
                                var hoursOfOperations = selectedMarker[0].hoursOfOperations
                                this.selectedMarkerDistance = selectedMarker[0].distance.description
                                var d = new Date();
                                var n = d.getDay()
                                if (d.getDay() == 0) {
                                    n = 6;
                                } else if (d.getDay() == 1) {
                                    n = 0;
                                } else {
                                    n = n - 1
                                }
                                var selectedDate = hoursOfOperations[n];
                                this.opensAt = selectedDate.opensAt
                                this.closesAt = selectedDate.closesAt
                                this.selectedMarker = selectedMarker[0];
                                this.teleUrl = "tel:" + this.selectedMarker.mobile;
                                this.stationMarkerStatus = marker.iconType
                            })
                        });
                    }                    
                });
                this.mapClickFlag =false;
                this.loaderTab =false;
            } catch(error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
            
        },
        deleteMarkers() {
            this.clearMarkers();
            this.markerArray = [];
        },
        setMapOnAll(map) {
            if (this.markerArray != null) {
                for (var i = 0; i < this.markerArray.length; i++) {
                    this.markerArray[i].setMap(map);
                }
            }
        },
        clearMarkers() {
            this.setMapOnAll(null);
        },
        formatDate(date) {
            var d = new Date(date);
            var hh = d.getHours();
            var m = d.getMinutes();
            var s = d.getSeconds();
            var dd = "AM";
            var h = hh;
            if (h >= 12) {
                h = hh - 12;
                dd = "PM";
            }
            if (h == 0) {
                h = 12;
            }
            m = m < 10 ? "0" + m : m;
            s = s < 10 ? "0" + s : s;
            var pattern = new RegExp("0?" + hh + ":" + m + ":" + s);
            var replacement = h + ":" + m;
            replacement += " " + dd;
            return replacement;
        },
        mapViegetLocation() {
            try {
                this.currentLoc = JSON.parse(localStorage.getItem("currentLoc"));
                this.locationAdd = localStorage.getItem("Autocomplete");

                var pos = {
                    lat: this.currentLoc.latitude,
                    lng: this.currentLoc.longitude
                };

                this.map.setCenter(pos);
                this.map.setZoom(this.configData.googleMapZoomLevel);

                this.filterCall();
            } catch(error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
            
        },
        async openScannerForTagId() {
            try {
                this.chargeNow = true;
                this.isShowingCamera = true;
                // let res = 'MTAwMDAwMjEtMTAwMDAwMDk2LTE=';
                // this.onDecode(res);
                
            } catch(error) {
                this.chargeNow = false;
                this.isShowingCamera = false;
                console.log(error)
            }
        },
        closeScanner() {
            this.chargeNow = false;
            this.isShowingCamera = false;
        },
        async onDetect (result) {
            // let stationId= '10000021'
            try {
                let stationInfoByQRCode = await new EVCStationService().getStationInfoByQRCodeValue(result[0].rawValue)
                if (stationInfoByQRCode.stationId) {
                    try {
                        let stationInfo = await new EVCStationService().stationWithId(stationInfoByQRCode.stationId);
                        var d = new Date();
                        var n = d.getDay()
                        if (d.getDay() == 0) {
                            n = 6;
                        } else if (d.getDay() == 1) {
                            n = 0;
                        } else {
                            n = n - 1
                        }
                        localStorage.setItem("teleUrl", stationInfo.mobile);
                        localStorage.setItem("selectedMarker", JSON.stringify(stationInfo));
                        localStorage.setItem("opensAt", stationInfo.hoursOfOperations[n].opensAt);
                        localStorage.setItem("closesAt", stationInfo.hoursOfOperations[n].closesAt);
                        localStorage.setItem('chargeNow', true);
                        localStorage.setItem('portId', stationInfoByQRCode.portId);
                        localStorage.setItem('outputNumber', stationInfoByQRCode.outputNumber)
                        localStorage.setItem("qrCodeValue", result[0].rawValue)
                        this.$router.push({ name: "bookNow" });
                    } catch(error) {
                        let serviceError = migratedTryParseServiceError(error);
                        new ToastUtils().presentToast(serviceError.description);
                    }
                } else {
                    this.chargeNow = false;
                    this.isShowingCamera = false;
                    new ToastUtils().presentToast("Invalid QR code");
                }
            } catch(error) {
                // new ToastUtils().presentToast(err);
                // new ToastUtils().presentToast(error.response.data.errors[0].detail);
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },
    }
})
</script>

<style scoped>
.qrcodeStream {
width: 50%;
height: 30%;
margin: 0 auto;
border: 5px solid #21b24b;
/* border-right: 5px solid #21b24b; */
border-radius: 5px;
margin-bottom: 90%;
}
.chargeNowFab {
    --background: #21b24b;
    /* --background: #21b24b; */
}
.qr-svg {
    width: 30px;
    color: rgb(250, 249, 249);
    /* font-weight: bolder; */
}
#pac-input:focus,
.res-content-wrapper .loc-search input:focus{
    padding: 12px;
    margin: 0;
}
    #res-map {
        height: 94%;
        width: 100%;
    }
.map-overlay{
    background: #000000;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    opacity: 0.3;
}
.spinnerWrapper{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%)
}
.map-wrapper {
    height: 100%;
    width: 100%;
}

.card-list-wrapper {
    position: absolute;
}

.res-content-wrapper {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 10;
    padding: 16px;
}

.card-list-content p.title {
    text-align: left;
    font-size: 16px;
    font-family: 'Roboto Medium';
    letter-spacing: 0;
    color: #313131;
    opacity: 1;
    margin-bottom: 8px;
}

.card-list-content p.time {
    font-family: 'Roboto Light';
}

.card-list-content p.loc,
.card-list-content p.time {
    text-align: left;
    margin-bottom: 8px;
    font-size: 15px;
    letter-spacing: 0;
    color: #313131;
    opacity: 0.75;
}

.card-list-booking p {
    height: 17px;
    text-align: right;
    margin-right: 8px;
    font-size: 14px;
    font-family: 'Roboto';
    letter-spacing: 0;
    color: #D66C6C;
    opacity: 1;
}

.card-list-booking {
    text-align: right;
}
.iocl-div-img {
    text-align: right;
}
.iocl_img {
    margin-top: -1rem;
    width: 300px;
    /* height: 15%; */
}
.call-options .book-btn {
    width: 115px;
    --background: #21b24b !important;
    border-radius: 36px;
    /* opacity: 1; */
    text-align: left;
    font-size: 16px;
    font-family: 'Roboto Medium';
    letter-spacing: 0;
    color: #FFFFFF;
    display: inline-block;
    position: relative;
    top: -15px;
}

.call-options {
    margin-top: 16px;
}

.call-options img.call-img {
    width: 24px;
    height: 24px;
    position: relative;
    top: -3px;
}

.call-options a.call-img-a {
    margin-right: 21px;
}

.call-options img.map-img {
    width: 36px;
    height: 36px;
    margin-right: 29px;
    cursor: pointer;
}

.card-list-content p.loc {
    font-family: 'Roboto';
}

.card-list-wrapper {
    bottom: 100px;
    width: 100%;
    padding: 0 30px;

}

@media (max-width: 768px) {
    .card-list-wrapper {
        padding: 0 14px;
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
    }
}

.card-list {
    height: 131px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 16px;
    opacity: 1;
    padding: 16px;
}

@media (max-width: 768px) {
    .card-list {
        height: 185px;
    }

    .card-list-booking {
        text-align: left !important;
        position: absolute;
        width: 100%;
        top: -36px;
    }

    .call-options .book-btn {
        position: absolute;
        top: 27px;
        right: 0px;
    }

    .card-list-booking p {
        position: relative;
        top: 6px;
    }

    .res-content-wrapper {
        padding: 0px !important;
    }
}

/* SearchBox */

.res-content-wrapper.listView .loc-search {
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #D6D6D6;
    background: #F4F5F9;
}

.res-content-wrapper.listView {
    background: #F4F5F9;
}

.res-content-wrapper .loc-search input {
    height: 52px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #0000001A;
    border-radius: 12px;
    opacity: 1;
    width: 100%;
    padding: 12px;
    padding-left: 98px !important;
    font-size: 14px;
    text-align: left;
    padding-left: 24px;
    font-family: 'Roboto';
    letter-spacing: 0;
    color: #9e9d9d;
}

.res-content-wrapper .loc-search img.map-marker-icon {
    width: 18px;
    height: 18px;
    opacity: 1;
    cursor: pointer;
}

.loc-wrpaper span {
    height: 17px;
    text-align: left;
    font-size: 14px;
    position: absolute;
    font-family: 'Roboto';
    letter-spacing: 0;
    top: 18px;
    padding-left: 18px;
    color: #404040;
    opacity: 1;

}

.loc-wrpaper img,
.loc-wrpaper span {
    z-index: 99;
}

.loc-wrpaper {
    position: relative;
}

.loc-wrpaper img.map-marker-icon {
    position: absolute;
    right: 12px;
    top: 17px;
    cursor: pointer;
}

@media (max-width: 768px) {
    .lense-icon{
        position: absolute;
    }
    .res-content-wrapper .loc-search input {
        padding-left: 50px !important;
        text-overflow: ellipsis;
        padding-right: 56px;
    }

    .res-content-wrapper .loc-search {
        padding: 9px;
    }
}
</style>
